const FETCH_ROLES = {
  START: 'START_FETCH_ROLES',
  COMPLETE: 'COMPLETE_FETCH_ROLES',
  FAIL: 'FAIL_FETCH_ROLES',
  CLEANUP: 'CLEANUP_FETCH_ROLES',
}

export default FETCH_ROLES
